import type { ReactNode } from "react";
import { Badge, Card, type BadgeTone } from "@/ui";
import { token } from "@/design/theme";

/**
 * VerdictPanel — the consent / publish-gate decision card. Renders the patient id, a COLOR + GLYPH +
 * TEXT verdict chip, a one-line explanation, and a discreet "live, never cached" note. Used by both
 * the consent-read screen and the seam-4 publish-gate screen (same live source, different framing).
 */
export function VerdictPanel({
  title,
  patientId,
  tone,
  glyph,
  verdictLabel,
  description,
  note,
}: {
  title: ReactNode;
  patientId: string;
  tone: BadgeTone;
  glyph: string;
  verdictLabel: ReactNode;
  description: ReactNode;
  note?: ReactNode;
}) {
  return (
    <Card title={title} style={{ maxWidth: 640 }}>
      <div style={{ display: "flex", flexDirection: "column", gap: token.s4 }}>
        <div style={{ display: "flex", alignItems: "center", gap: token.s3, flexWrap: "wrap" }}>
          <Badge tone={tone} glyph={glyph}>
            {verdictLabel}
          </Badge>
          <span className="nv-mono nv-ltr-island" style={{ color: token.slate, fontSize: token.fsCaption }}>
            #{patientId}
          </span>
        </div>
        <p style={{ margin: 0, color: token.ink, fontSize: token.fsBody }}>{description}</p>
        {note && (
          <p style={{ margin: 0, color: token.steel, fontSize: token.fsCaption }}>{note}</p>
        )}
      </div>
    </Card>
  );
}
